/**
 * Helpers para el sistema de favoritos de la biblioteca.
 *
 * RLS garantiza que cada usuario solo lee/escribe sus propios favoritos.
 * No hace falta filtrar por user_id en las queries — Supabase lo enforce.
 */
import { supabase } from './supabase';

/** Devuelve el Set con los material_id que el usuario tiene marcados. */
export async function listMyFavoriteIds(): Promise<Set<string>> {
  const { data, error } = await supabase
    .from('library_favorites')
    .select('material_id');
  if (error) {
    console.error('[favorites] listMyFavoriteIds error:', error);
    return new Set();
  }
  return new Set((data ?? []).map((r: any) => r.material_id));
}

/**
 * Toggle: si está marcado lo borra, si no, lo agrega.
 * Retorna el nuevo estado booleano (`true` = ahora es favorito).
 *
 * Optimista en UI: el caller puede asumir éxito y revertir solo si retorna
 * `null` (error).
 */
export async function toggleFavorite(materialId: string, currentlyFavorite: boolean): Promise<boolean | null> {
  if (currentlyFavorite) {
    const { error } = await supabase
      .from('library_favorites')
      .delete()
      .eq('material_id', materialId);
    if (error) {
      console.error('[favorites] toggleFavorite delete error:', error);
      return null;
    }
    return false;
  } else {
    // user_id se completa por la policy WITH CHECK pero igual lo enviamos
    // para evitar trip de RLS — usamos auth.getUser() para tenerlo.
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      console.error('[favorites] toggleFavorite: no auth user');
      return null;
    }
    const { error } = await supabase
      .from('library_favorites')
      .insert({ user_id: user.id, material_id: materialId });
    if (error) {
      console.error('[favorites] toggleFavorite insert error:', error);
      return null;
    }
    return true;
  }
}
